import { AnimatePresence, motion } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import styles from './RemoveCoachModal.module.css';
import globalButtonStyles from '../../styles/ButtonGradient.module.css';

const RemoveCoachModal = ({ coachName, onConfirm, isOpen, onClose }) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={styles.modal}
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <button
              className={styles.closeButton}
              onClick={onClose}
              aria-label="Close remove coach modal"
            >
              <FiX />
            </button>
            <h2 className={styles.heading}>
              Remove <strong>{coachName}</strong> as your coach?
            </h2>
            <div className={styles.buttonRow}>
              <button
                type="button"
                className={`${globalButtonStyles.button} ${styles.acceptButton}`}
                onClick={handleConfirm}
              >
                Yes, Remove
              </button>
              <button
                type="button"
                className={`${globalButtonStyles.button} ${styles.declineButton}`}
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default RemoveCoachModal;